function cov_2ki2w648jw() {
  var path = "/app/src/components/snippet-content/index.tsx";
  var hash = "0a40e77e1a761eee90f8acdb645f89ce4ae0c11c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-content/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0a40e77e1a761eee90f8acdb645f89ce4ae0c11c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ki2w648jw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ki2w648jw();
export { SnippetContent } from './snippet-content';